var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { createClient, createConfig } from "@hey-api/client-fetch";
import { getGoogleReCaptchaToken } from "@jti/fe-clients";
import { sanitizeBaseUrl } from "../../../utils";
import { createOrUpdateMarketingCommunication, deleteMarketingCommunication } from "../../evo-client/__generated__";
export class SnpApiEvo {
    constructor(baseUrl, tenantToken, recaptchaId) {
        this.tenantToken = tenantToken;
        this.recaptchaId = recaptchaId;
        this.name = "SnpApi";
        this.client = createClient(createConfig({ baseUrl: sanitizeBaseUrl(baseUrl), throwOnError: true }));
    }
    subscribe(subscriptionData, preferredLanguage) {
        return __awaiter(this, void 0, void 0, function* () {
            const { consent_purposes, email, preferredLanguage: preferredLanguageFromForm } = subscriptionData;
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            const { data } = yield createOrUpdateMarketingCommunication({
                client: this.client,
                headers: {
                    "X-DES-TENANT": this.tenantToken,
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                },
                body: {
                    email,
                    category: "marketing",
                    consents: consent_purposes,
                    preferredLanguage: preferredLanguage !== null && preferredLanguage !== void 0 ? preferredLanguage : preferredLanguageFromForm,
                },
            });
            const { uuid = "", category = "" } = data || {};
            return { languageUpdated: false, topics: [category], uuid };
        });
    }
    unsubscribe(subscriptionUuid, topics) {
        return __awaiter(this, void 0, void 0, function* () {
            const recaptchaToken = yield getGoogleReCaptchaToken(this.recaptchaId);
            yield deleteMarketingCommunication({
                client: this.client,
                headers: {
                    "X-DES-RECAPTCHA-TOKEN": recaptchaToken,
                    "X-DES-TENANT": this.tenantToken,
                },
                path: {
                    identifier: subscriptionUuid,
                },
            });
            return Promise.resolve({ languageUpdated: false, topics, uuid: subscriptionUuid });
        });
    }
}
//# sourceMappingURL=SnpApiEvo.js.map